export default "__VITE_ASSET__ab04f7d0__"